class InterceptorMock {
	/** @ngInject */
	constructor($injector) {
		this.$injector = $injector;
		this.api = $injector.get('API');
		this.request = this.requestFn.bind(this);
	}

	requestFn(config) {
		let shouldBeMock;
		if (config.method === 'POST' && config?.data) {
			shouldBeMock = config.data?.mock === true;
		} else if (config.method === 'GET') {
			if (config?.params?.mock === true) {
				shouldBeMock = true;
				delete config.params.mock;
			} else {
				const url = new URL(config.url, window.location.origin);
				if (url.searchParams.get('mock') === 'true') {
					shouldBeMock = true;
					url.searchParams.delete('mock');
					config.url = url.pathname + url.search;
				}
			}
		}

		if (shouldBeMock) {
			config.url = config.url.replace(this.api, 'http://localhost:3001');
		}

		return config;
	}

	static create($injector) {
		return new InterceptorMock($injector);
	}
}
//
InterceptorMock.create.$inject = ['$injector'];
export default InterceptorMock;
